<div class="layout-col full">
  <span style="width: 90vw"></span>

  <app-production-list-conf-detail class="flex" [prodListConf]="conf" (close)="onClose($event)">
  </app-production-list-conf-detail>
</div>
